var render = function render(){var _vm=this,_c=_vm._self._c;return _c('batch-upload-attachment',{attrs:{"attachmentFieldName":_vm.attachmentFieldName,"batchUploadUrl":_vm.batchUploadUrl,"checkedItems":_vm.checkItems,"doQuery":_vm.doQuery,"modelName":_vm.modelName,"title":_vm.title,"uploadUrl":_vm.uploadUrl,"voName":_vm.voName}})
}
var staticRenderFns = []

export { render, staticRenderFns }